import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from '../../types/applicationContext';
import { IReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { RecommendationsLayout } from '../../components/RecommendationsLayout';
import { RecommendationsContainer } from '../RecommendationsContainer';
import { ChatModalContainer } from '../ChatModalContainer';
import { NotAvailablePopupContainer } from '../NotAvailablePopupContainer';
import { IVisitedOffersProviderProps, VisitedOffersProvider } from '@cian/frontend-visited-offers-widget';
import { ErrorContainer } from '../ErrorContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
    config,
  } = context;

  const { settings, enabled } = config.get<IVisitedOffersProviderProps>('audience.visitedOffers') || {};

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <VisitedOffersProvider settings={settings} enabled={enabled}>
              <ErrorContainer />
              <RecommendationsLayout>
                <RecommendationsContainer />
                <ChatModalContainer />
                <NotAvailablePopupContainer />
              </RecommendationsLayout>
            </VisitedOffersProvider>
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
